<template>
  <el-container height="auto">
    <el-main>


        <el-form ref="form" :model="form"  :rules="rules" label-width="100px">
           <el-row >
              <el-col :span="24">
                <el-form-item label="研究名称">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="研究说明" >
              <el-input type="textarea" v-model="form.description"></el-input>
            </el-form-item>
            
            <el-form-item label="手机访问" >
              <el-switch v-model="form.allowmobile"></el-switch>
            </el-form-item>

            <el-form-item style="text-align:center">
              <el-button type="primary" @click="onSave">保存</el-button>
            </el-form-item>
            
          </el-form>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        form: {
          name: '',
          description: '',
          allowmobile: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ]
        },
      }
    },
    mounted(){
      
    },
    methods: {
      onSave(){
          this.form.allowmobile = (this.form.allowmobile)?"1":"0";

          this.$http.post('project/new', this.form).then((res) => {
              if(!res) return;

              //提醒成功
              this.$message({ type:'success', message:'新的研究创建成功'})
              
              //清除内容
              this.form = {};

              this.$router.push({ path: '/home/project', query:{}})
          }); 
          
      },
      
    }
  }
</script>
<style scoped>

</style>